<template>
  <div>
    <topic-list v-show="tabType === 1" @handleShow="handleShow" />
    <topic-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import topicList from './list.vue'
import topicShow from './show.vue'
export default {
  components: { topicList, topicShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>